import { Map } from 'immutable';
import { locationsListActions } from './actions';
import { createLocationsList } from './locations-list';

export const initialState = new Map({
  currentLocationsListtId: null
});

export const locationsListsReducer = (state =  initialState  , {payload, type} ) => {
//console.log(payload, type)
  switch (type) {
    case locationsListActions.FETCH_LOCATIONS_SUCCESS:

      return state.withMutations(locationslist => {
          locationslist.set(payload.id, createLocationsList(payload));
      });
    case locationsListActions.LOAD_LOCATIONS:
      return state.set('currentLocationsListtId', payload.id);

    default:
      return state;
  }
}
